<template>
  <div-box :src="require('../../assets/img/zichan_bg@2x.png')">
    <nav-bar left-arrow :title="`USDT ${$t('钱包')}`" bgColor="#000000" />
    <vant-up-down ref="list" @list="(val) => (list = val)" res="res.data.data" :noToken="false"
      url="/api/v1/user/balance_log?trade_type=1" :data="{}">
      <div-padding padding="4vw">
        <div-card height="35vw" padding='3vw'>
          <div-height height='5vw' />
          <div-text color='#fff' align="center" size='7vw'>
            {{ usdt||0 }}
          </div-text>
          <div-text color='#999' align="center" size='3.5vw'>{{ $t('可用') }}USDT</div-text>
        </div-card>
        <div-padding padding="4vw 0">
          <div-flex left>
            <div-img width='4vw' height='4vw'>
              <img src="../../assets/img/zujian@2x.png" alt="">
            </div-img>
            <div-width width='1vw' />
            <div-text color='#fff' size='4vw'>{{ $t('流水明细') }}</div-text>
          </div-flex>
        </div-padding>
        <div-card bg='#242424' margin="0 0 3vw 0" padding='3vw' v-for="(item, index) in list" :key="index">
          <div-flex>
            <div-text color='#fff' size='4vw'>{{ item.remark }}</div-text>
            <div-text color='#CEB082' size='4vw'>{{ item.amount > 0 ? "+" : "" }}{{ item.amount }} USDT</div-text>
          </div-flex>
          <van-divider style="margin:3vw 0" />
          <!-- <div-text color='#999' size='3.5vw'>提现地址：183948bsdufib289383</div-text> -->
          <!-- <div-flex left>
            <div-text color='#999999' size='3.5vw'>手续费：</div-text>
            <div-text color='#CEB082' size='3.5vw'>1.2%</div-text>
          </div-flex> -->
          <div-text color='#999' size='3.5vw'>{{ $t('操作时间') }}：{{ item.created_at }}</div-text>
        </div-card>
      </div-padding>
    </vant-up-down>
  </div-box>
</template>

<script>
  export default {
    data() {
      return {
        active: 0,
        usdt: "",
        list: [],
      }
    },
    created() {
      this.up_down()
      this.get_info()
    },
    methods: {
      get_info() {
        this.$get({
          url: "/api/v1/user/info",
          success: (res) => {
            this.usdt = res.data.usdt
          },
          tip: () => { },
        })
      },
    },
  }
</script>
<style lang='less' scoped></style>